<template>
  <li class="km__list__element">
    <span :class="'km__label ' + idAndName">Icon</span>
    <button
        :style="{'background-color': backgroundColor }"
        :id="idAndName"
        :class="cssclass" type="button"
        :name="idAndName"
        @click="$emit('click')"
    >
      {{ text }}
    </button>
  </li>
</template>

<script lang="ts" setup>
import {computed} from "vue";

const props = defineProps({
  backgroundColor: String,
  idAndName: String,
  additionalClasses: Array,
  text: String,
  hasOutline: Boolean
})

const cssclass = computed(() => ["km__button--standard", (props.additionalClasses as string[]).join(" "), (props.hasOutline ? "" : "nooutline")].join(" "))


</script>

<style lang="scss" scoped>
@use "../../scss/settings/config" as config;
@use "../../scss/settings/mixins.scss" as mixins;

.km__button {
  &--standard {
    &.fontcolor,
    &.outlinecolor {
      @include mixins.hide-text;
      width: 60px;
      background-color: config.$color-white;
      display: inline-block;
      position: relative;

      &.active {
        &:after {
          @include mixins.color-active;
        }
      }
    }

    &.outlinecolor {
      &:before {
        content: '';
        position: absolute;
        left: 5px;
        top: 5px;
        width: calc(100% - 10px);
        height: calc(100% - 10px);
        z-index: 99;
        background: config.$color-white;
        border: 1px solid config.$color-btn-border;
      }
    }

    &.outlinecolor {
      &.nooutline {
        background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNS4yLjIsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA2MCAyNSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNjAgMjU7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOm5vbmU7c3Ryb2tlOiNCNUI1QjU7c3Ryb2tlLXdpZHRoOjEuNTtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9DQo8L3N0eWxlPg0KPGc+DQoJPGc+DQoJCTxsaW5lIGNsYXNzPSJzdDAiIHgxPSIwLjkiIHkxPSIyNC4yIiB4Mj0iNTkuMSIgeTI9IjAuOCIvPg0KCTwvZz4NCjwvZz4NCjxnPg0KCTxwYXRoIGQ9Ik01OSwxdjIzSDFWMUg1OSBNNjAsMEgwdjI1aDYwVjBMNjAsMHoiLz4NCjwvZz4NCjxnPg0KCTxwYXRoIGQ9Ik01My4xLDYuOHYxMS4zSDYuOVY2LjhINTMuMSBNNTQuMSw1LjhINS45djEzLjNoNDguM1Y1LjhMNTQuMSw1Ljh6Ii8+DQo8L2c+DQo8L3N2Zz4NCg==') no-repeat center;
        background-size: 60px 25px;

        &:before {
          display: none;
        }
      }
    }
  }
}

.km__label {
  &.fontcolor {
    background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjQsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMDAgMTAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojMzMzMzMzO30NCgkuc3Qxe2ZpbGw6I0ZDNTYyNDt9DQoJLnN0MntmaWxsOiMyMzgzQkE7fQ0KCS5zdDN7ZmlsbDojRjRFNjI0O30NCjwvc3R5bGU+DQo8Zz4NCgk8Zz4NCgkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTc1LjQsNjJINTN2LTNsMC4xLDBjMi40LTAuMywzLjQtMC43LDMuOC0xLjNjMC40LTAuNiwwLjEtMS42LTAuNC0zLjFjLTAuNy0yLjItMS45LTUuNS0zLTguM0gzOS41DQoJCQljLTAuMiwwLjUtMC40LDEuMS0wLjYsMS43Yy0wLjcsMS45LTEuNCwzLjgtMS45LDUuNWMtMC42LDEuOS0wLjcsMy4xLTAuMiwzLjhjMC43LDEuMSwyLjUsMS40LDYuMSwxLjdsMC4xLDB2M0gyNC42di0zbDAuMSwwDQoJCQljNC42LTAuNiw1LjctMS4yLDguMi03LjNsMTUuMy0zOGw0LjYsMC4ybDAsMC4xYzMuMiw4LjgsNi42LDE3LjQsOS45LDI1LjdjMS41LDMuOCwzLDcuNyw0LjUsMTEuNWMyLjgsNi45LDMuNCw3LjMsOCw3LjhsMC4xLDANCgkJCVY2MnogTTQwLjksNDIuMmgxMS4zbC01LjUtMTVjLTAuMywwLjctMC42LDEuNC0wLjksMi4xQzQ0LjEsMzMuNyw0Mi40LDM3LjgsNDAuOSw0Mi4yeiIvPg0KCTwvZz4NCjwvZz4NCjxnPg0KCTxyZWN0IHg9IjI0LjYiIHk9IjY5LjciIGNsYXNzPSJzdDEiIHdpZHRoPSIxNyIgaGVpZ2h0PSIxNyIvPg0KCTxyZWN0IHg9IjQxLjQiIHk9IjY5LjciIGNsYXNzPSJzdDIiIHdpZHRoPSIxNyIgaGVpZ2h0PSIxNyIvPg0KCTxyZWN0IHg9IjU4LjQiIHk9IjY5LjciIGNsYXNzPSJzdDMiIHdpZHRoPSIxNyIgaGVpZ2h0PSIxNyIvPg0KPC9nPg0KPC9zdmc+DQo=');
  }

  &.outlinecolor {
    background-image: url('data:image/svg+xml;base64,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');
  }
}
</style>